import {
  Organization,
  OrganizationVaProfile,
  VAStatus,
  VaOnboardingType,
  VaOrganizationProfileStatus,
} from "schemas/dashboard";
import { Map } from "schemas/functions";
import { routes } from "schemas/routes";

import { isPage } from "utils/general";

export function getOnboardingPage(currentPathname: string) {
  if (currentPathname.endsWith(routes.welcomeOnboarding)) {
    return "welcomePage";
  } else if (currentPathname.endsWith(routes.aboutOnboarding)) {
    return "aboutForm";
  } else if (currentPathname.endsWith(routes.categoryOnboarding)) {
    return "categoryForm";
  }
}

export function onboardingNavigate(
  currentPathname: string,
  onboardingForm: Map,
  direction: "next" | "back",
) {
  if (currentPathname.endsWith(routes.welcomeOnboarding)) {
    // only forward
    return routes.aboutOnboarding;
  } else if (currentPathname.endsWith(routes.aboutOnboarding)) {
    // only forward
    if (direction === "next") {
      return routes.categoryOnboarding;
    }
  } else if (currentPathname.endsWith(routes.categoryOnboarding)) {
    if (direction === "back") {
      return routes.aboutOnboarding;
    } else {
      return routes.income;
    }
  } else if (currentPathname.endsWith(routes.income)) {
    if (direction === "back") {
      return routes.categoryOnboarding;
    } else {
      return routes.finalOptIn;
    }
  } else if (currentPathname.endsWith(routes.finalOptIn)) {
    if (direction === "back") {
      return routes.income;
    } else {
      return routes.home;
    }
  }
}

export const getVaOnboardingRoute = (
  organization: Organization,
  vaProfile: OrganizationVaProfile,
  link: string,
) => {
  // Edge case, user clicked an Import link in an email.
  if (isPage(routes.virtualAssistant)) {
    return `/${routes.virtualAssistant}`;
  } else if (link?.includes(routes.tracking)) {
    return link;
  }
  const isOnboarding =
    organization.vaStatus === VAStatus.pending ||
    (organization.signedUpForVa &&
      organization.vaStatus !== VAStatus.not_interested &&
      organization.vaStatus !== VAStatus.disqualified);
  if (!isOnboarding) return "";
  if (vaProfile?.status === VaOrganizationProfileStatus.completed) {
    return "";
  }
  if (vaProfile?.onboardingType === VaOnboardingType.self_serve) {
    return `/${routes.onboardingVaSelfServe}`;
  }
};
